import React from 'react';
import { CountdownBadge } from './CountdownBadge';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-gradient-to-b from-stone-50 to-white pt-8 pb-16 md:pt-12 md:pb-24 overflow-hidden" data-id="element-37">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-38">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-39">
          <div className="lg:w-3/5 space-y-6 md:space-y-8 z-10" data-id="element-40">
            <div className="inline-block" data-id="element-41">
              <CountdownBadge data-id="element-42" />
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-[1.1] tracking-tight text-center lg:text-left" data-id="element-43">
              Detén la{' '}
              <span className="text-red-600" data-id="element-44">"Inflamación por Cortisol"</span>{' '}
              que el cardio y las dietas no pueden tocar.
            </h1>

            <h2 className="text-xl md:text-2xl font-medium text-gray-600 leading-relaxed" data-id="element-45">
              El protocolo de 5 minutos diseñado para mujeres de 40+ que
              despiertan cansadas, viven inflamadas y no logran bajar el vientre
              a pesar de "hacerlo todo bien".
            </h2>

            <div className="bg-white border-l-4 border-teal-500 p-5 md:p-6 shadow-md rounded-r-xl" data-id="element-46">
              <p className="text-lg text-gray-800 italic font-medium" data-id="element-47">
                "Te miras al espejo por la mañana y no te reconoces. No es solo
                el peso; es esa pesadez en el abdomen, la cara hinchada y la
                fatiga que te arrastra desde las 11 AM."
              </p>
            </div>

            <p className="text-lg text-gray-700" data-id="element-48">
              Has intentado comer menos. Has intentado correr más. Pero tu
              cuerpo parece estar en una "huelga de hambre" interna, aferrándose
              a cada gramo de grasa abdominal como si su vida dependiera de
              ello.
            </p>

            <div className="pt-4 flex flex-col sm:flex-row items-center gap-4" data-id="element-49">
              <CTAButton data-id="element-50" />
            </div>
            <div className="flex items-center justify-center sm:justify-start space-x-4 text-sm text-gray-500 font-medium" data-id="element-51">
              <span className="flex items-center" data-id="element-52">
                <span className="text-green-500 mr-1" data-id="element-53">✓</span> Pago Seguro
              </span>
              <span className="flex items-center" data-id="element-54">
                <span className="text-green-500 mr-1" data-id="element-55">✓</span> Acceso Inmediato
              </span>
            </div>
          </div>

          <div className="lg:w-2/5 w-full max-w-md mx-auto relative" data-id="element-56">
            <div className="absolute inset-0 bg-teal-200 rounded-full blur-3xl opacity-30 transform -translate-y-10" data-id="element-57"></div>
            <img src="https://cdn.magicpatterns.com/uploads/1MMMpT3fh8bLULHySRKhN7/PORTADA_INFLAMACION.png" alt="El Protocolo de Reinicio de Cortisol" className="w-full h-auto relative z-10 drop-shadow-2xl rounded-2xl transform hover:scale-[1.02] transition-transform duration-500" fetchPriority="high" data-id="element-58" />
          </div>
        </div>
      </div>
    </section>;
}